import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JackBaseComponentModule, jkLib, login } from "jk-service";
import { MtrwdService, MtrwlService } from '../../_service_mtr';
import { Mtrwl } from '../../_entity_mtr';

type SaveState = 'idle' | 'editing' | 'saving' | 'saved' | 'failed';
export const MtrWl012List =  [ { id:"T" , name:"text" },{ id:"H" , name:"html" },{ id:"M" , name:"markdown" } ] ; // 格式

@Component({
  selector: 'app-notes',
  standalone: true,
  imports: [FormsModule, JackBaseComponentModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './notes.component.html',
  styleUrl: './notes.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NotesComponent implements OnInit, OnDestroy {
  mtrwdSrv: MtrwdService = new MtrwdService();
  categoryChange($event: string) {
    this.dirty = true;
    this.category.set($event);
  }
  //private readonly noteService = inject(NoteService);
  readonly mtrwlSrv = inject(MtrwlService);
  isTiptapEditor = signal(false);
  notes = signal<Mtrwl[]>([]);
  total = signal(0);
  visibleCount = signal(40);
  visibleNotes = computed(() => this.notes().slice(0, this.visibleCount()));
  currentNote = signal<Mtrwl | null>(null);
  subject = signal('');
  get wl001(): string {
    return this.currentNote()?.WL001 ?? '';
  }
  wl002 = signal('');
  wl003 = signal(99);
  wl004 = signal('');
  wl005 = signal(jkLib.nowDate());
  wl012 = signal('M');
  wl015 = signal(0);
  wl016 = signal('');
  markdown = signal('');
  category = signal('04');
  //categoryOptions = CATEGORY_OPTIONS;
  query = signal('');
  starredOnly = signal(false);
  loading = signal(false);
  errorMessage = signal('');
  saveState = signal<SaveState>('idle');
  feedback = signal('');

  private autoSaveTimer: ReturnType<typeof setTimeout> | null = null;
  private searchTimer: ReturnType<typeof setTimeout> | null = null;
  private savingPromise: Promise<void> | null = null;
  private editRevision = 0;
  private dirty = false;

  ngOnInit(): void {
    this.loadNotes();
  }

  ngOnDestroy(): void {
    if (this.autoSaveTimer !== null) clearTimeout(this.autoSaveTimer);
    if (this.searchTimer !== null) clearTimeout(this.searchTimer);
    this.flushAutoSave().catch(() => { });
  }

  scheduleSearch(): void {
    if (this.searchTimer !== null) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadNotes(), 300);
  }
  /*
  async createNote(): Promise<void> {
    await this.flushAutoSave();
    this.errorMessage.set('');
    try {
      const note = await this.mtrwlSrv.create();
      this.notes.update((items) => [note, ...items]);
      this.total.update((value) => value + 1);
      this.openEditor(note);
      this.saveState.set('saved');
    } catch (error) {
      this.errorMessage.set(error instanceof Error ? error.message : String(error));
    }
  }*/

  async openNote(note: Mtrwl): Promise<void> {
    await this.flushAutoSave();
    this.openEditor(note);
  }

  async showList(): Promise<void> {
    await this.flushAutoSave();
    this.currentNote.set(null);
    this.saveState.set('idle');
    await this.loadNotes();
  }

  editSubject(value: string): void {
    this.subject.set(value.slice(0, 100));
    this.markEdited();
  }
  editWL003(value: string): void {
    this.wl003.set(Number(value));
    this.markEdited();
  }
  editWL005(value: string): void {
    this.wl005.set(value);
    this.markEdited();
  }
  editWL015(value: string | number): void {
    this.wl015.set(Number(value) || 0);
    this.markEdited();
  }

  toggleArchiveModal(): void {
    const note = this.currentNote();
    /* 	時間線
      00	每日/記事
      01	程式
      02	google
      03	股票
      04	日記
      W	工作 */
    if(note) {
      if(note.WL014==='W'){// 工作
        //this.archiveSameDateToWorkCategory('note',note.WL005,note.WL012,note.WL014);
        this.mtrwdSrv.importMtrwl('note',note.WL005,note.WL012,note.WL014);
      }
    }
  }

  // 歸檔方式 1：同一日期合併歸到同一分類單頭 (工作類)
  archiveSameDateToWorkCategory(prefix:string, date: string, format:string,group: string): void {
    // TODO: 下次補規格實作 (同一日期合併歸到同一分類單頭 (工作類))
    this.mtrwdSrv.importMtrwl(prefix,date,format,group);
    console.log('歸檔方式：同一日期合併歸到同一分類單頭 (工作類)');
    alert('【歸檔-同一日期合併歸至工作類單頭】功能待實作');

  }

  // 歸檔方式 2：同一月份單身(日記)
  archiveSameMonthDiary(wl014:string,wl005:string): void {
    // TODO: 下次補規格實作 (同一月份單身(日記))
    console.log('歸檔方式：同一月份單身(日記)');
    alert('【歸檔-同一月份單身(日記)】功能待實作');

  }

  editmarkdown(value: string): void {
    this.markdown.set(value); // value.slice(0, 4000)
    this.markEdited();
  }

  editCategory(value: string): void {
    const validValue = value?.trim() || '04';
    this.category.set(validValue);
    this.markEdited();
  }

  getCategoryLabel(code?: string | null): string {

    const found = this.mtrwlSrv.MtrWd015List.find((item) => item.id === code);
    return found ? found.name : (code || '04 日記');
  }

  async flushAutoSave(): Promise<void> {
    if (this.autoSaveTimer !== null) {
      clearTimeout(this.autoSaveTimer);
      this.autoSaveTimer = null;
    }
    await this.saveNow();
  }

  async retrySave(): Promise<void> {
    await this.saveNow();
  }

  async toggleStar(note: Mtrwl, event?: Event): Promise<void> {
    event?.stopPropagation();
    try {
      const updated = await this.mtrwlSrv.setStarred(note, note.WL007 !== 'Y');
      this.replaceNote(updated);
      if (this.currentNote()?.WL001 === updated.WL001 && this.currentNote()?.WL002 === updated.WL002) {
        this.currentNote.set(updated);
      }
      if (this.starredOnly() && updated.WL008 !== 'Y') {
        this.notes.update((items) => items.filter((item) => !this.sameNote(item, updated)));
      }
    } catch (error) {
      this.errorMessage.set(error instanceof Error ? error.message : String(error));
    }
  }

  async deleteCurrent(): Promise<void> {
    const note = this.currentNote();
    if (!note || !window.confirm('確定要永久刪除這則筆記嗎？此操作無法復原。')) return;
    try {
      await this.mtrwlSrv.delete(note);
      this.notes.update((items) => items.filter((item) => !this.sameNote(item, note)));
      this.total.update((value) => Math.max(0, value - 1));
      this.currentNote.set(null);
      this.saveState.set('idle');
    } catch (error) {
      this.errorMessage.set(error instanceof Error ? error.message : String(error));
    }
  }

  async copymarkdown(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.markdown());
      this.feedback.set('內文已複製');
    } catch {
      this.feedback.set('無法存取剪貼簿');
    }
    window.setTimeout(() => this.feedback.set(''), 2200);
  }

  onListScroll(event: Event): void {
    const element = event.currentTarget as HTMLElement;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 120) {
      this.visibleCount.update((value) => Math.min(value + 40, this.notes().length));
    }
  }

  private openEditor(note: Mtrwl): void {
    this.currentNote.set(note);
    this.subject.set(note.WL007 || '');
    this.wl003.set(Number(note.WL003 || 99));
    this.wl005.set(note.WL005 || jkLib.nowDate());
    this.wl015.set(Number(note.WL015 || 0));
    this.markdown.set(note.WL013 || '');
    this.category.set(note.WL014 || '04');
    this.wl002.set(note.WL002 || '');
    this.dirty = false;
    this.saveState.set('saved');
    this.errorMessage.set('');
  }

  private markEdited(): void {
    if (!this.currentNote()) return;
    this.editRevision += 1;
    this.dirty = true;
    this.saveState.set('editing');
    if (this.autoSaveTimer !== null) clearTimeout(this.autoSaveTimer);
    this.autoSaveTimer = setTimeout(() => {
      this.autoSaveTimer = null;
      this.saveNow();
    }, 800);
  }

  private async saveNow(): Promise<void> {
    if (this.savingPromise) await this.savingPromise;
    const note = this.currentNote();
    if (!note || !this.dirty) return;
    const revision = this.editRevision;
    this.saveState.set('saving');
    this.savingPromise = (async () => {
      try {
        note.WL003 = this.wl003();
        note.WL004 = this.wl004();
        note.WL005 = this.wl005();
        note.WL007 = this.subject();
        note.WL012 = this.wl012();
        note.WL013 = this.markdown();
        note.WL014 = this.category() || '04';
        note.WL015 = this.wl015();
        note.WL016 = this.wl016();
        const updated = await this.mtrwlSrv.update(note);
        this.replaceNote(updated);
        if (this.currentNote() && this.sameNote(this.currentNote()!, updated)) {
          this.currentNote.set(updated);
        }
        if (revision === this.editRevision) {
          this.dirty = false;
          this.saveState.set('saved');
        } else {
          this.saveState.set('editing');
        }
      } catch (error) {
        this.saveState.set('failed');
        this.errorMessage.set(error instanceof Error ? error.message : String(error));
      }
    })();
    await this.savingPromise;
    this.savingPromise = null;
    if (this.dirty && revision !== this.editRevision && this.autoSaveTimer === null) {
      this.autoSaveTimer = setTimeout(() => {
        this.autoSaveTimer = null;
        this.saveNow();
      }, 800);
    }
  }

  private replaceNote(note: Mtrwl): void {
    this.notes.update((items) => items.map((item) => this.sameNote(item, note) ? note : item));
  }

  private sameNote(left: Mtrwl, right: Mtrwl): boolean {
    return left.WL001 === right.WL001 && left.WL002 === right.WL002;
  }
  //---------------------------------------------------------------------
  async createNote(): Promise<void> {
    await this.flushAutoSave();
    this.errorMessage.set('');
    try {
      const note = await this.mtrwlSrv.create('', '', this.wl014());
      //this.currentNote.set(note);
      this.notes.update((items) => [note, ...items]);
      this.total.update((value) => value + 1);

      this.subject.set(note.WL007 || '');
      this.wl003.set(Number(note.WL003 || 99));
      this.wl005.set(note.WL005 || jkLib.nowDate());
      this.markdown.set(note.WL013 || '');
      //this.wl014.set('04');
      this.openEditor(note);
      this.saveState.set('saved');
      this.dirty = false;
    } catch (error) {
      this.errorMessage.set(
        error instanceof Error ? error.message : String(error),
      );
    }
  }




  /*
  private markEdited(): void {
    if (!this.currentNote()) return;
    this.revision += 1;
    this.dirty = true;
    this.saveState.set('editing');
    if (this.autoSaveTimer !== null) clearTimeout(this.autoSaveTimer);
    this.autoSaveTimer = setTimeout(() => {
      this.autoSaveTimer = null;
      this.saveNow();
    }, 800);
  }*/

  /*
  private async saveNow(): Promise<void> {
    if (this.savingPromise) await this.savingPromise;
    const note = this.currentNote();
    if (!note || !this.dirty) return;
    const revision = this.editRevision;
    this.saveState.set('saving');
    this.savingPromise = (async () => {
      try {
        const updated = await this.mtrwlSrv.update(
          note,
          this.subject(),
          this.markdown(),
          this.wl014(),
        );
        this.currentNote.set(updated);
        if (revision === this.editRevision) {
          this.dirty = false;
          this.saveState.set('saved');
        }
      } catch (error) {
        this.saveState.set('failed');
        this.errorMessage.set(
          error instanceof Error ? error.message : String(error),
        );
      }
    })();
    await this.savingPromise;
    this.savingPromise = null;
  }*/
  // notes--------------------------
  readonly wl014 = signal('04');
  async loadNotes(): Promise<void> {
    this.loading.set(true);
    this.errorMessage.set('');
    try {
      const response = await this.mtrwlSrv.getNotesList(this.query(), this.starredOnly());
      this.notes.set(response);
      this.total.set(response.length);
      this.visibleCount.set(40);
    } catch (error) {
      this.errorMessage.set(error instanceof Error ? error.message : String(error));
    } finally {
      this.loading.set(false);
    }
  }
  getImagePath(item: Mtrwl | null): string {
    return item ? `${item.WL001}-${item.WL002}` : 'unknown';
  }
  get host() {
    return login.host;
  }
  get WL004() {
    return this.wl004();
  }
  set WL004(value: string) {
    this.wl004.set(value);
  }
  get WL016() {
    return this.wl016();
  }
  set WL016(value: string) {
    this.wl016.set(value);
  }
  get WL012(){
    return this.wl012();
  }
  set WL012(value:string){
    this.wl012.set(value);
  }
  MtrWl012List= MtrWl012List;

  getContentView(note: Mtrwl): string {
    if (note.WL013 !== '') {
      return note.WL013 || '';
    }
    if (note.WL004 !== '') {
      return note.WL004 || '';
    }
    if (note.WL016 !== '') {
      return note.WL016 || '';
    }
    return '';
  }


}
